import {Grid, makeStyles, Typography} from "@material-ui/core";
import React, {useEffect, useState} from 'react';
import Cube from "../../../Domain/Models/Cube";
import cube_icon from "../../../Icons/cube-centre.png"
import cube_right_icon from "../../../Icons/Cube-right.png"
import cube_left_icon from "../../../Icons/Cube-left.png"
import group_icon from "../../../Icons/Group-icon.png"
import {CubeColumn} from "./CubeElementsList";
import {CubeStateService} from "../../../Domain/Services/CubeStateService";
import {CubeState} from "../../../Domain/Models/CubeState";
import {date} from "yup";
import GroupElementsList from "./GroupElementsList";
import GroupElement from "./GroupElement";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  root: {
    margin: 'auto',
    maxWidth: '150px'
  },
  name: {
    color: '#FFFFFF'
  },
  usage: {
    color: '#FA4A70'
  },
  info: {
    color: '#848282',
    marginBottom: '-2px',
  },
  activeContainer: {
    position: 'relative',
    top: 0,
    left: 0,
  },
  cubeIcon: {
    position: 'relative',
    width: '100%',
    marginTop: '-10px',
  },
  activeGroup: {
    position: 'absolute',
    display: 'flex',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
  },
  headerBar: {
    height: '2px',
    width: '100%',
    marginLeft: 'auto',
    backgroundColor: '#FA4A70'
  }
}));

export interface CubeElementProps
{
  cube: Cube;
  cubeColumn : CubeColumn;
  index: number;
}

let requestInProgressRef: any = {};
export default function CubeElement(props: CubeElementProps)
{
  const classes = useStyles();
  const {cube, cubeColumn, index} = props;

  const [requestInProgress, setRequestInProgress] = useState(false);
  const [cubeState, setCubeState] = useState<CubeState>({
    id: cube.id,
    name: cube.name,
    maintenanceMode: cube.maintenanceMode,
    activeGroupArrivalTime: new Date(Date.now())
  });
  
  const getCubeIcon = () =>
  {
    switch (cubeColumn)
    {
      case CubeColumn.Center:
        return cube_icon;
      case CubeColumn.Left:
        return cube_left_icon;
      case CubeColumn.Right:
        return cube_right_icon;
    }
  }

  requestInProgressRef[cube.id] = requestInProgress;
  const stateLoop = () =>
  {
    if (requestInProgressRef[cube.id])
    {
      return;
    }

    setRequestInProgress(true);
    CubeStateService.getState(cube.id)
      .then((state: CubeState) =>
      {
        setCubeState(state);
        setRequestInProgress(false);
      })
      .catch((e: Error) =>
      {
        console.error(e);
        setRequestInProgress(false);
      })
  }
  
  const getLoopDelay = (): number =>
  {
    let column;
    switch (cubeColumn)
    {
      case CubeColumn.Left:
        column = 0;
        break;
      case CubeColumn.Center:
        column = 1;
        break;
      case CubeColumn.Right:
        column = 2;
        break;
    }
    
    return 1000 * column + 100 * index;
  };
  
  useEffect(() =>
  {
    stateLoop();
    
    const interval = setInterval(stateLoop, 10000);
    return () => clearInterval(interval);
  }, [])

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography className={classes.name} component="p" variant="body1" align='right'>
          {cube.name}
        </Typography>
      </Grid>
      
      <Grid item xs={3}>
        { cubeState.groupInQueueLine && (
          <GroupElement group={cubeState.groupInQueueLine} />
        )}
      </Grid>
      
      <Grid item xs={4}>
        <div className={classes.activeContainer} >
        <img src={getCubeIcon()} alt="Cube" className={classes.cubeIcon}/>
        { cubeState.activeGroup && (
          <div className={classes.activeGroup}>
            <GroupElement group={cubeState.activeGroup} />
          </div>
        )}
        </div>
      </Grid>
      
      <Grid item xs={5}>
        <div className={classes.headerBar}/>
        { cube.maintenanceMode && (
          <Typography className={classes.usage} component="p" variant="body2" align='right'>
            MAINTENANCE MODE
          </Typography>
        )}
        <Typography className={classes.info} component="p" variant="body2" align='right'>
          {cube.numberOfPlayers}
        </Typography>
        <Typography className={classes.info} component="p" variant="body2" align='right'>
          {cube.lengthOfGame}
        </Typography>
        <Typography className={classes.info} component="p" variant="body2" align='right'>
          {cube.gameType}
        </Typography>
        <Typography className={classes.info} component="p" variant="body2" align='right'>
          {cube.difficultyTypes.join(', ')}
        </Typography>
      </Grid>
    </Grid>
  )
}